import { BASE_URL } from '@/lib/constants';
import { buildValidationError } from '@/utils/validationErrors';

export type CreateAccountInput = {
  plot_id: number;
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
  locale: string;
};

const apiBase = BASE_URL;

export async function createAccount(input: CreateAccountInput): Promise<void> {
  if (!apiBase) {
    throw new Error('Registration server is not configured.');
  }

  const payload = {
    ...input,
    terms: true,
  };

  let response: Response;

  try {
    response = await fetch(`${apiBase}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch {
    throw new Error('Unable to reach the registration server.');
  }

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw buildValidationError(body, 'We could not create your account.', response.status);
  }
}
